var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83.3159,
    height: 121.024,
    viewBox: "103.336 51.6084 83.3159 121.024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.088 133.872C125.193 133.872 126.088 134.768 126.088 135.872V141.14C126.088 145.354 128.195 147.46 132.408 147.46H153.58C157.794 147.46 159.9 145.354 159.9 141.14V126.288C159.9 122.075 157.372 119.968 152.316 119.968H132.67C131.566 119.968 130.67 119.073 130.67 117.968V101.744C130.67 100.64 131.566 99.7444 132.67 99.7444H152.316C154.634 99.7444 156.266 99.3231 157.214 98.4804C158.162 97.5324 158.636 95.8471 158.636 93.4244V81.1004C158.636 76.8871 156.53 74.7804 152.316 74.7804H133.672C129.459 74.7804 127.352 76.8871 127.352 81.1004V86.3684C127.352 87.473 126.457 88.3684 125.352 88.3684H106.6C105.496 88.3684 104.6 87.473 104.6 86.3684V76.3604C104.6 70.0404 106.812 64.6684 111.236 60.2444C115.66 55.8204 121.032 53.6084 127.352 53.6084H158.636C164.956 53.6084 170.328 55.8204 174.752 60.2444C179.176 64.6684 181.388 70.0404 181.388 76.3604V92.7924C181.388 98.959 179.068 103.947 174.426 107.756C173.204 108.759 173.291 110.798 174.599 111.686C179.968 115.327 182.652 120.405 182.652 126.92V145.88C182.652 152.2 180.44 157.572 176.016 161.996C171.592 166.42 166.22 168.632 159.9 168.632H126.088C119.768 168.632 114.396 166.42 109.972 161.996C105.548 157.572 103.336 152.2 103.336 145.88V135.872C103.336 134.768 104.232 133.872 105.336 133.872H124.088Z",
    fill: "#1B191A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.088 133.872C125.193 133.872 126.088 134.768 126.088 135.872V141.14C126.088 145.354 128.195 147.46 132.408 147.46H153.58C157.794 147.46 159.9 145.354 159.9 141.14V126.288C159.9 122.075 157.372 119.968 152.316 119.968H132.67C131.566 119.968 130.67 119.073 130.67 117.968V101.744C130.67 100.64 131.566 99.7444 132.67 99.7444H152.316C154.634 99.7444 156.266 99.3231 157.214 98.4804C158.162 97.5324 158.636 95.8471 158.636 93.4244V81.1004C158.636 76.8871 156.53 74.7804 152.316 74.7804H133.672C129.459 74.7804 127.352 76.8871 127.352 81.1004V86.3684C127.352 87.473 126.457 88.3684 125.352 88.3684H106.6C105.496 88.3684 104.6 87.473 104.6 86.3684V76.3604C104.6 70.0404 106.812 64.6684 111.236 60.2444C115.66 55.8204 121.032 53.6084 127.352 53.6084H158.636C164.956 53.6084 170.328 55.8204 174.752 60.2444C179.176 64.6684 181.388 70.0404 181.388 76.3604V92.7924C181.388 98.959 179.068 103.947 174.426 107.756C173.204 108.759 173.291 110.798 174.599 111.686C179.968 115.327 182.652 120.405 182.652 126.92V145.88C182.652 152.2 180.44 157.572 176.016 161.996C171.592 166.42 166.22 168.632 159.9 168.632H126.088C119.768 168.632 114.396 166.42 109.972 161.996C105.548 157.572 103.336 152.2 103.336 145.88V135.872C103.336 134.768 104.232 133.872 105.336 133.872H124.088Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter13",
    x: 103.336,
    y: 51.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 132.619,
    y1: 53.6084,
    x2: 132.619,
    y2: 168.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.f4bf9c4913e84d23d2eae84d4888d2f3.svg";
export { ForwardRef as ReactComponent };